import * as React from "react"
import PropTypes from "prop-types"
import { useAsync } from "@react-hook/async"
import { Button } from "components/Button"
import { Modal, ModalContent, ModalActions } from "components/Modal"
import { useTranslator } from "components/Translator"

export const ConfirmButton = ({
  children,
  confirmTitle,
  confirmContent,
  confirmLabel,
  onConfirm,
  ...buttonProps
}) => {
  const translator = useTranslator()

  const [showConfirmModal, setShowConfirmModal] = React.useState(false)

  const [{ status }, confirm] = useAsync(async () => {
    await onConfirm()
    setShowConfirmModal(false)
  })

  return (
    <>
      <Button
        {...buttonProps}
        type="button"
        onClick={() => setShowConfirmModal(true)}
      >
        {children}
      </Button>
      <Modal
        isOpen={showConfirmModal}
        title={confirmTitle}
        onRequestClose={() => setShowConfirmModal(false)}
      >
        <ModalContent>{confirmContent}</ModalContent>
        <ModalActions>
          <Button
            type="button"
            color="danger"
            busy={status === "loading"}
            disabled={status === "loading"}
            onClick={confirm}
          >
            {confirmLabel}
          </Button>
          <Button
            type="button"
            variant="outline"
            color="secondary"
            onClick={() => setShowConfirmModal(false)}
            disabled={status === "loading"}
          >
            {translator.trans("ConfirmButton.cancel", null, "components")}
          </Button>
        </ModalActions>
      </Modal>
    </>
  )
}

ConfirmButton.propTypes = {
  children: PropTypes.node,
  confirmTitle: PropTypes.string,
  confirmContent: PropTypes.node,
  confirmLabel: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
}
